export function renderUserEmailInline(item) {
  if (item?.user_status === "DELETED") {
    return (
      <>
        {item?.email} (UserID: {item?.id}, Deleted)
      </>
    );
  }

  return item?.email ?? "-";
}

export function renderUserEmailStacked(item) {
  if (item?.user_status === "DELETED") {
    return (
      <>
        <span>{item?.email}</span>
        <div className="format-user-email__deleted-text">(UserID: {item?.id}, Deleted)</div>
      </>
    );
  }

  return item?.email ?? "-";
}

export function getUserTooltipHTML(item) {
  if (item?.user_status === "DELETED") {
    return `${item?.email}<br/>(UserID: ${item?.id}, Deleted)`;
  }

  return item?.email ?? "-";
}

export function getTooltipAttributes(isEnabled, user) {
  if (!isEnabled || user?.user_status !== 'DELETED') return {};
  
  return {
    'data-tooltip-id': 'tooltip',
    'data-tooltip-html': getUserTooltipHTML(user),
    'data-tooltip-place': 'bottom-end',
  };
}